import { Modal, Typography, Button, Stack, IconButton } from "@mui/material";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";
import CloseIcon from "@mui/icons-material/Close";
import WarningImage from "assets/illustrations/warning.png";
import CardMyCnpjs from "../CardMyCnpjs/CardMyCnpjs";
import { useConsigazApi } from "hooks/useConsigazApi";
import { toast } from "react-toastify";
import { useAuth } from "hooks/useAuth";

export default function DeleteLinkCnpjModal({
  open,
  onClose,
  name,
  cnpj,
  refresh,
}) {
  const { userCpf } = useAuth();

  const api = useConsigazApi();

  if (!open) return null;

  const handleDelete = async () => {
    try {
      await api.deleteLinkCnpj({ cnpj, cpf: userCpf });
      toast.success("Vínculo cancelado com sucesso.");
      onClose();
      refresh();
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus disableEnforceFocus>
      <ContentModal
        borderRadius={"8px"}
        p={"40px 32px"}
        display={"flex"}
        flexDirection={"column"}
        textAlign={"center"}
        gap={"28px"}
      >
        <Stack position={"absolute"} top={10} right={20}>
          <IconButton onClick={onClose}>
            <CloseIcon
              sx={{
                color: "#053462",
                fontSize: "31px",
              }}
            />
          </IconButton>
        </Stack>

        <Stack alignItems={"center"} gap={"10px"}>
          <img src={WarningImage} height={80} width={80} alt="Modal img" />

          <Typography color="#EB2128" fontSize={"24px"} fontWeight={600}>
            Cancelamento de vínculo
          </Typography>
        </Stack>

        <Typography fontSize={"14px"} fontWeight={500} textAlign={"left"}>
          Após o cancelamento do vínculo, a revenda não estará mais associada ao
          seu grupo. Para reestabelecer vínculo e permitir o acesso, será
          necessária uma nova validação com login e código de cliente.
        </Typography>
        <CardMyCnpjs name={name} cnpj={cnpj} deleting />
        <Button
          onClick={handleDelete}
          sx={{
            alignSelf: "flex-end",
            color: "#EB2128",
            fontSize: "18px",
            fontWeight: 700,
          }}
        >
          Cancelar vínculo
        </Button>
      </ContentModal>
    </Modal>
  );
}
